export default __webpack_public_path__ + "michael@2x.a7016b61.jpg";